/**
 * THE VISITOR-PASS SHARE LINK, as the desk's camera reads it (resident-portal
 * Plan 6, RP-6.4).
 *
 * The guest's pass page shows a QR of its own URL, `<app>/p/<token>`. The desk
 * decodes it on the tablet and needs the token alone. What counts as a pass:
 *
 *   https://app.lobbero.com/p/<43 base64url characters>   (a trailing slash too)
 *   <43 base64url characters>                            (a bare token)
 *
 * The HOST is not checked, on purpose: the server resolves the token and is the
 * only authority on whether it is a pass at all, and a host check here would
 * refuse every pass shown on a staging or local build whose share URLs name a
 * different origin. Anything else — an invite link, a website, text — is null,
 * and the desk says so without asking the server.
 */

const TOKEN = /^[A-Za-z0-9_-]{43}$/;
const PATH = /^\/p\/([A-Za-z0-9_-]{43})\/?$/;

export const isPassToken = (value: string): boolean => TOKEN.test(value);

export const tokenFromScan = (value: string | null | undefined): string | null => {
  const text = String(value ?? '').trim();
  if (!text) return null;
  if (TOKEN.test(text)) return text;
  let url: URL;
  try {
    url = new URL(text);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
  const match = PATH.exec(url.pathname);

  return match ? match[1] : null;
};
